import { render, staticRenderFns } from "./RateCategoryDetail.vue?vue&type=template&id=57612737&scoped=true"
import script from "./RateCategoryDetail.vue?vue&type=script&lang=js"
export * from "./RateCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./RateCategoryDetail.vue?vue&type=style&index=0&id=57612737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57612737",
  null
  
)

export default component.exports